import { Button, Popconfirm } from 'antd';
import { useUpdate } from '@refinedev/core';

type Props = {
  recordId: string;
};

export const FinishButton = ({ recordId }: Props) => {
  const { mutate } = useUpdate();

  return (
    <Popconfirm
      title="終了しますか？"
      okText="はい"
      cancelText="いいえ"
      onConfirm={() => {
        mutate({
          resource: 'experienceReservations',
          id: recordId,
          values: {
            status: 'finished',
          },
          meta: {
            fields: [
              {
                experienceReservation: ['id', 'status'],
              },
            ],
          },
        });
      }}
    >
      <Button type="primary" danger>
        終了
      </Button>
    </Popconfirm>
  );
};
